import React, { useRef, useEffect, useState } from 'react';
import axios from 'axios';
import useInterval from '@use-it/interval';
import { setVideoPlayerPlaying } from '../actions'
import { useDispatch, useSelector } from 'react-redux'
//import videojs from 'video.js'
// import {
//    registerIVSQualityPlugin,
//    registerIVSTech,
// } from 'amazon-ivs-player';
import 'video.js/dist/video-js.css';
import '@videojs/themes/dist/city/index.css';
import $script from 'scriptjs'

const JSON5 = require('json5')

import HtmlContent from "src/shared/html_content"
import RenderedHtmlContent from 'src/shared/virtual_congress/components/rendered_html_content'
import VideoPlayerOverlay from 'src/shared/video/video_room/player/video_player_overlay.jsx'
import {VelocityTransitionGroup, VelocityComponent} from 'velocity-react';
import useScript from 'src/shared/service/use_script'

require('velocity-animate');
require('velocity-animate/velocity.ui');
//import videojs from 'video.js'
//import 'videojs-vr/dist/videojs-vr.min.js'

//const createAbsolutePath = (assetPath) => new URL(assetPath, document.URL).toString();


export default function VideoJsPlayer({ videoRoom, streamSource, playerType, playerConfig, ...props }) {

  const isAmazonPlayer = playerType == "amazon_ivs"
  const tagOwner = useSelector(state => state.tagOwner)

  //console.log("props", videoRoom, streamSource, isAmazonPlayer, playerConfig, Object.values(props))

  const entranceUrl = props.entranceUrl
  const videoPlayerPlaying = useSelector(state => state.videoPlayerPlaying)
  const player = useRef(null)
  const dispatch = useDispatch()
  const videRoomEvent = useSelector(state => state.events.find(event => event.id == videoRoom.event_id))

  // needed because videojs dispose removes the dom element

  const [ended, setEnded] = useState(false)

  const [videoJsLoaded, setVideoJsLoaded] = useState(false)
  const [amazonIvsLoaded, setAmazonIvsLoaded] = useState(false)
  const [amazonIvsQualityLoaded, setAmazonIvsQualityLoaded] = useState(false)
  const [videoJs360Loaded, setVideoJs360Loaded] = useState(false)
  const everythingLoaded = isAmazonPlayer ? (videoJsLoaded && amazonIvsLoaded && amazonIvsQualityLoaded) : (playerConfig?.projection360 ? (videoJs360Loaded && videoJsLoaded) : videoJsLoaded)

  const [parsedPlayerConfig, setParsedPlayerConfig] = useState({})


  const enableFullscreenHtmlFinishedContents = (elementId) => {
    if (videoRoom.finished_html_content) {
      let player = document.getElementById(elementId)
      console.log("attaching finished html", elementId, player)
      if(player) {
        let nav = document.getElementById("video-finished-overlay")
        if (player != undefined && !player.contains(nav)) {
          console.log("attaching div")
          player.appendChild(nav)
        }
      }
    }
  }



  $script("https://cdnjs.cloudflare.com/ajax/libs/video.js/7.14.3/video.min.js", () => {
    if(parsedPlayerConfig?.projection360) {
      $script('https://cdn.jsdelivr.net/npm/videojs-vr@1.7.1/dist/videojs-vr.min.js', () => {
        setVideoJs360Loaded(true)
      })
    }
    setVideoJsLoaded(true)
  })

  $script('https://player.live-video.net/1.13.0/amazon-ivs-videojs-tech.min.js', () => {
    setAmazonIvsLoaded(true)
  })

  $script('https://player.live-video.net/1.13.0/amazon-ivs-quality-plugin.min.js', () => {
    setAmazonIvsQualityLoaded(true)
  })

  useEffect(() => {
    try {
      //let newConf = playerConfig.replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t")
      //console.log({newConf})
      let parsedNewConf = JSON5.parse(playerConfig)
      setParsedPlayerConfig(parsedNewConf)
      console.log("Loaded successfully", parsedNewConf)
    } catch(ex) {
      console.error("Could not parse player config", ex, playerConfig)
    }
  }, [playerConfig])


  useEffect(() => {
    if(everythingLoaded && isAmazonPlayer) {
      registerIVSTech(videojs)
      registerIVSQualityPlugin(videojs)
    }
  }, [isAmazonPlayer, everythingLoaded])

  useEffect(() => {
      // console.table({
      //   isAmazonPlayer: isAmazonPlayer,
      //   videoJsLoaded: videoJsLoaded,
      //   amazonIvsLoaded: amazonIvsLoaded,
      //   amazonIvsQualityLoaded: amazonIvsQualityLoaded,
      //   videoJs360Loaded: videoJs360Loaded,
      // })
    if(!everythingLoaded) {
      //console.warn("Not loaded")
      return 
    }
    //console.warn("Loaded!")

    const playerId = "player" + String(new Date().getTime())

    const playerVideo = document.createElement('video');
    playerVideo.id = playerId
    playerVideo.className = "video-js vjs-fluid vjs-big-play-centered"
    playerVideo.playsInline = true
    playerVideo.controls = true
    document.getElementById("videojs-wrapper").appendChild(playerVideo);

    const generalPlayerConfig = { 
      logLevel: "debug", 
      poster: videRoomEvent?.images?.video_player_poster_image?.xl?.url,
      controlBar: {
        //fullscreenToggle: false,
        pictureInPictureToggle: false
      },
    }

    if(isAmazonPlayer) {
      // IF IVS:
      // Note that when instantiating the player, the Video.js sources option is not supported. 
      generalPlayerConfig.techOrder = ["AmazonIVS"]
    } else {
      generalPlayerConfig.sources = [{src: streamSource}]
    }
    let finalPlayerConfig = Object.assign({}, generalPlayerConfig, parsedPlayerConfig)
    console.log("Using player config", {isAmazonPlayer}, finalPlayerConfig)

    player.current = videojs(playerId, finalPlayerConfig, () => {
      console.debug('onPlayerReady', this)
      if(finalPlayerConfig.volume) {
        console.log("Setting volume", finalPlayerConfig.volume)
        player.current.volume(finalPlayerConfig.volume)
      }

      player.current.on("ended", () => {
        console.debug("ENDED")
        setEnded(true)
        if(videoPlayerPlaying){ dispatch(setVideoPlayerPlaying(false)) }
      })
      player.current.on("pause", () => {
        console.debug("pause")
        if(videoPlayerPlaying){ dispatch(setVideoPlayerPlaying(false)) }
      })
      player.current.on("play", () => {
        console.debug("PLAYING")
        setEnded(false)
        if(!videoPlayerPlaying){ dispatch(setVideoPlayerPlaying(true)) }
      })
      player.current.on("seeked", () => {
        console.debug("PLAYING")
        setEnded(false)
      })
      player.current.on('fullscreenchange', (e) => {
        console.log("fullscreenschangee", e, playerId)
        enableFullscreenHtmlFinishedContents(playerId)

        if(props.onFullscreenChange) {
          console.log("Triggering props.onFullscreenChange")
          props.onFullscreenChange.call(this, playerId)
        }
      });

      if (props.ontimeupdate) {
        player.current.on('timeupdate', (e) => {
          props.ontimeupdate(e, player.current.currentTime())
        });
      }


      if(isAmazonPlayer) {
        player.current.enableIVSQualityPlugin()
        player.current.src(streamSource)
      } else {
        if(parsedPlayerConfig?.projection360) {
          console.warn("Enabling 360 player")
          player.current.vr({projection: '360'});
        }
      }
    })

    return () => {
      if(player.current) {
        player.current.dispose()
      }
    }
  }, [playerType, streamSource, parsedPlayerConfig, everythingLoaded])

  useEffect(() => {
    if (player.current && props.ontimeupdate) {
      player.current.on('timeupdate', (e) => {
        props.ontimeupdate(e, player.current.currentTime())
      });
    }
  }, [props.ontimeupdate, player.current])

  useInterval(() => {
    if(player?.current && !player?.current?.paused()) {
      if(!videoPlayerPlaying){
        dispatch(setVideoPlayerPlaying(true))
      }
      //console.warn("playing")
    } else {
      if(videoPlayerPlaying){
        dispatch(setVideoPlayerPlaying(false))
      }
      //console.warn("Not playing")
    }
  }, 3000);

  if(!everythingLoaded) {
    return <p className="text-center" style={{height: "20vh"}}>
      <i className="fa fa-spinner fa-spin fa-5x" style={{marginTop: "10vh"}}/>
    </p>
  }

  return (
      <div className="flave-video-container">
        <div
          onClick={props.onPlayerClick}
          className="videojs_player_container"
          style={{width: "100%", position: "relative", backgroundColor: "black", minHeight: "30px"}}>
            
            <div id="videojs-wrapper"/>
            {videoRoom.finished_html_content && 
              <div id="video-finished-overlay" style={{
                zIndex: 9999999, 
                position: "absolute", 
                top: "0px", 
                bottom: "0",
                left: "0px",
                pointerEvents: "none",
                right: "0", 
                width: "100%",
                overflow: "hidden"}}
              >
              <VelocityTransitionGroup enter={{animation: "fadeIn", duration: 2 * 1000}}
                                       leave={{animation: "fadeOut", duration: 2 * 1000}}>
                {ended &&
                  <div key={"video_vjshtml" + videoRoom.updated_at + videoRoom.finished_html_content} >
                    <RenderedHtmlContent html={videoRoom.finished_html_content} placeholders={{tagOwner: tagOwner}}/>
                  </div>
                }
              </VelocityTransitionGroup>
              </div>
            }
            {props.children}
          </div>
      </div>
  )
}
